<template>
  <div id="service-list" class="right-content">
      <v-row class="m-0">
         <v-col class="pl-3">
          <v-radio-group row v-model="radioGroup" @change="$event=>filterStatus($event)"> 
            <v-radio
              v-for="item in optionFilter"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col class="text-right">
          <button class="btn btn-deactive mr-3" v-if="radioGroup === true && selected.length > 0" @click="dialog = true" style="margin-top: 16px;">{{ $t("DEACTIVE") }}</button>
          <button class="btn btn-deactive mr-3" v-if="radioGroup === false && selected.length > 0" @click="dialogActive = true" style="margin-top: 16px;">{{ $t("ACTION_ACTIVE") }}</button>
          <button class="btn btn-delete mr-3" v-if="selected.length > 0" @click="$refs.deleteDialogComponentList.open(selected)" style="margin-top: 16px;">{{ $t("DELETE") }}</button>
          <button class="btn btn-copy" @click="addNew()" style="margin-top: 16px;">{{ $t("ADD_NEW") }}</button>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
           <v-simple-table
              :dense="false"
              :fixed-header="true"
              :height="500"
            >
            <template v-slot:default>
              <thead class="thead">
                <tr>
                  <th width="7%"  class="text-center" scope="col">
                    <input type="checkbox" v-model="checkAll" :value="true" @change="getAll()"/>
                  </th>
                  <th width="7%"  class="text-center"  scope="col" v-if="radioGroup === 'all' || radioGroup == true"><span>{{ $t("SERVICE.ORDER") }}</span></th>
                  <th width="8%" class="text-left" scope="col"><span>{{ $t("SERVICE.THUMBNAIL") }}</span></th>
                  <th width="15%" class="text-left" scope="col"><span>{{ $t("SERVICE.CODE") }}</span></th>
                  <th width="10%" class="text-left" scope="col"><span>{{ $t("SERVICE.NAME") }}</span></th>
                  <th width="15%" class="text-left" scope="col"><span>{{ $t("SERVICE.PRICE_STATUS") }}</span></th>
                  <th width="15%" class="text-left" scope="col"><span>{{ $t("SERVICE.STATUS") }}</span></th>
                  <th width="10%" align="middle" scope="col"><span>{{ $t("ACTION") }}</span></th>
                </tr>
              </thead>
              <draggable v-model="listFilter" tag="tbody" animation="150" handle=".sortHandle" @end="changeOrderListService">
                <tr v-for="item in listFilter" :key="item.id">
                  <td width="7%" class="text-center">
                    <input type="checkbox" v-model="selected" :value="item" @change="checkAllSelect()"/>
                  </td>
                  <td width="7%" v-if="radioGroup === 'all' || radioGroup == true"><v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn></td>
                  <td width="8%" scope="row"><img v-bind:src="item.urlImage" style="width:85px;"></td>
                  <td width="15%">{{ item.serviceCode }}</td>
                  <td width="10%">{{ item.serviceName.find(x => x.lang == sysLang).name }}</td>
                  <td width="15%">
                      <div v-if="item.free">
                        {{ $t("SERVICE.FREE") }}
                      </div>
                      <div v-else>
                        {{ $t("SERVICE.PREMIUM") }}
                      </div>
                  </td>
                  <td width="15%">
                    <v-switch
                      v-model="item.active"
                      @change="updateStatus(item)"
                      class="service-status"
                    ></v-switch>
                  </td>
                  <td width="10%">
                    <span class="edit" @click="editItem(item)">{{ $t("EDIT") }}</span>
                    <span class="delete" @click="$refs.deleteDialogComponent.open(item)">{{ $t("DELETE") }}</span>
                  </td>
                </tr>
              </draggable>
            </template>
          </v-simple-table>
          <!-- <v-data-table v-if="radioGroup === false"
              :headers="headers"
              :items="listFilter"
              disable-sort
              hide-default-footer
              item-key="id"
              class="main-table-service"
              show-select
              v-model="selected"
            >
           
            <template v-slot:item.urlImage="{ item }">
              <img v-bind:src="item.urlImage" style="width: 85px;">
            </template>
            <template v-slot:item.serviceName="{ item }">
              {{ item.serviceName.find(x => x.lang == sysLang).name }}
            </template>
            <template v-slot:item.free="{ item }">
              <div v-if="item.free">
                {{ $t("SERVICE.FREE") }}
              </div>
              <div v-else>
                {{ $t("SERVICE.PREMIUM") }}
              </div>
            </template>
            <template v-slot:item.active="{ item }">
             <v-switch
                v-model="item.active"
                @change="updateStatus(item)"
                class="service-status"
              ></v-switch>
            </template>
            <template v-slot:item.action="{ item }">
              <span class="edit" @click="editItem(item)">{{ $t("EDIT") }}</span>
              <span class="delete" @click="$refs.deleteDialogComponent.open(item)">{{ $t("DELETE") }}</span>
            </template>
            
          </v-data-table> -->
          <delete-dialog @deleteItem="deleteService" :maxWidth="325" ref="deleteDialogComponent">
            <v-card-title slot="title" class="headline p-0">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}?</v-card-title>
          </delete-dialog>
           <delete-dialog @deleteItem="deleteServiceList" :maxWidth="325" ref="deleteDialogComponentList">
            <v-card-title slot="title" class="headline p-0">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}?</v-card-title>
          </delete-dialog>
            <v-dialog  v-model="dialog" max-width="418" >
              <v-card>
                <v-card-title class="headline">{{$t('SERVICE.CONFIRM_DEACTIVE_SERVICE')}}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <button class="btn btn-delete mr-5" @click="dialog = false">  {{ $t("CLOSE") }} </button>
                    <button class="btn btn-deactive" @click="deactiveAll()">{{ $t("CONFIRM") }}</button>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog  v-model="dialogActive" max-width="418" >
              <v-card>
                <v-card-title class="headline">{{$t('SERVICE.CONFIRM_ACTIVE_SERVICE')}}</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <button class="btn btn-delete mr-5" @click="dialogActive = false">  {{ $t("CLOSE") }} </button>
                    <button class="btn btn-deactive" @click="deactiveAll()">{{ $t("CONFIRM") }}</button>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-col>
      </v-row>
  </div>
</template>

<style lang="scss" scoped>
.table-syncPMS {
  padding: 0;
  .v-card__text {
    padding: 0;
  }
}
#service-list {
  td {
    vertical-align: middle;
  }
  button.sortHandle {
    outline: none;
  }
  .service-status {
    justify-content: center;
    margin-top: 5px;
  }
}

</style>

<script>
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import draggable from "vuedraggable";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { servicePackageService } from "@/_services/Service/service.service.js";

export default {
  components: {
    draggable,
    "delete-dialog": DeleteDialog,
  },
  data () {
    return {
      dialog: false,
      dialogActive: false,
      checkAll: false,
       headers: [
        {
          text: this.$t("SERVICE.THUMBNAIL"),
          align: "left",
          value: "urlImage",
          width: "120px"
        },
        {
          text: this.$t("SERVICE.CODE"),
          align: "left",
          value: "serviceCode"
        },
        {
          text: this.$t("SERVICE.NAME"),
          align: "left",
          value: "serviceName",
        },
        {
          text: this.$t("SERVICE.PRICE_STATUS"),
          align: "left",
          value: "free",
        },
        {
          text: this.$t("SERVICE.STATUS"),
          align: "left",
          value: "active",
        },
         {
          text: this.$t("ACTION"),
          align: "left",
          value: "action",
        }
      ],
      sysLang: this.$i18n.locale || "vi",
      radioGroup: true,
      selected: [],
      listService:[],
      listFilter: [],
      dragging: false,
      dialog: false,
      headers_PMS: [
        {
          text: this.$t("SERVICE.CODE"),
          sortable: false,
          value: 'code',
        },
        { 
          text: this.$t("SERVICE.NAME"),
          sortable: false,
          value: 'name'
        },
        { 
          text: this.$t("SERVICE.PRICE"),
          sortable: false,
          value: 'price'
        },
        { 
          text: this.$t("SERVICE.CURRENCY"),
          sortable: false,
          value: 'currency'
        },
        { type: 'checkbox', class: "checkbox-class" }
      ],
      itemPMS: [
        {
          code: 1,
          name: 'Frozen Yogurt 1',
          price: 6.0,
          currency: 24
        },
        {
          code: 2,
          name: 'Frozen Yogurt 2',
          price: 6.0,
          currency: 24
        },
        {
          code: 3,
          name: 'Frozen Yogurt 3',
          price: 6.0,
          currency: 24
        },
      ],
      selected: [],
      optionFilter: [
        {
          label: this.$t("SERVICE.ACTIVE"), 
          key: true
        },
        {
          label: this.$t("SERVICE.DEACTIVE"), 
          key: false
        },
        {
          label: this.$t("ALL"), 
          key: 'all'
        }
      ]
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      await servicePackageService.get().then(res => {
        this.listService = res.data.services;
        this.listFilter = res.data.services;
      });
      this.filterStatus(true);
    },
    // dynamicsort(property,order) {
    //   var sort_order = 1;
    //   if(order === "desc"){
    //       sort_order = -1;
    //   }
    //   return function (a, b){
    //       // a should come before b in the sorted order
    //       if(a[property] < b[property]){
    //               return -1 * sort_order;
    //       // a should come after b in the sorted order
    //       }else if(a[property] > b[property]){
    //               return 1 * sort_order;
    //       // a and b are the same
    //       }else{
    //               return 0 * sort_order;
    //       }
    //   }
    // },
    getAll() {
      if (this.checkAll === true) {
        this.selected = [...this.listFilter];
      } else {
        this.selected = [];
      }
    },
    checkAllSelect() {
      if (this.selected.length === this.listFilter.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    changeOrderListService(){
      const tmp = [];
      this.listFilter.forEach( element=> {
        tmp.push(element.id);
      } );

      servicePackageService.sortService(tmp).then(res => {
        // _alert(res, this.$t(res.data), res.responseCode != 0 );
      });
    },
    updateStatus(item) {
      servicePackageService.updateStatus(item.id).then(res => {
        _alert(res, this.$t(res.data), res.responseCode != 0 );
      });
    },
    deactiveAll() {
      const body = [];
        this.selected.forEach( element => {
          body.push(element.id);
          }
        );
       servicePackageService.updateStatusAll(body).then(res => {
         this.dialog = false;
        _alert(res, this.$t(res.data), res.responseCode === 0 );
      });
    },
    filterStatus(event) {
      this.checkAll = false;
      this.getAll();
      if ( event == 'all' ) {
        this.listFilter = this.listService; 
      } else {
        this.listFilter = this.listService.filter(item=>item.active === event);
      }
    },
    addNew() {
      this.$router.push({ name: "serviceDetail", params: { type: 'create' , id : 0 } });
    },
    editItem(item){
      this.$router.push({ name: "serviceDetail", params: { type: 'edit' , id : item.id } });
    },
    deleteService(item) {
      servicePackageService.deleteService(item.id).then(res => {
        _alert(res, this.$t(res.data), true );
      });
    },
    deleteServiceList(items) {
      const body = [];
      items.forEach( element => {
        body.push(element.id);
        }
      );
      servicePackageService.deleteServiceList(body).then(res => {
        _alert(res, this.$t(res.data), true );
      });
    },
    syncPMS() {
      this.$router.push({ name: "ServiceSyncPMS" });
    },
  }
};
</script>